import type { Feedback, InsightsProperty, OCCompany, Ownerships } from 'bundles/connect/types';
import { saveLlcData } from '../../../helpers/local_storage';
import {
  UPDATE_CALL_CONSOLE_AI_COMPANY_FEEDBACK,
  UPDATE_CALL_CONSOLE_OWNERSHIP_FEEDBACK
} from '../actions/ai_related_companies';
import {
  ADD_CALL_CONSOLE_OWNERSHIP,
  DELETE_CALL_CONSOLE_OWNERSHIP,
  SET_CALL_CONSOLE_DATA,
  SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE,
  SET_CALL_CONSOLE_VERIFIED_OWNER,
  UPDATE_CALL_CONSOLE_CONTACT,
  UPDATE_CALL_CONSOLE_DATA,
  SET_CALL_LIST_ITEM_ID
} from '../actions/call_console';

type CallConsoleStateType = {
  insightsProperty?: InsightsProperty;
  aiRelatedCompanies?: {
    id: number;
    feedback: Feedback;
  }[];
  owners?: Ownerships[];
  ocCompany?: OCCompany;
  callListItemId?: number;
}

export default function(state: CallConsoleStateType = {}, action): CallConsoleStateType {
  switch (action.type) {
  case SET_CALL_CONSOLE_DATA:
    return action.payload;
  case UPDATE_CALL_CONSOLE_DATA:
    if (state.insightsProperty?.propertyId && action.payload.ocCompany) {
      saveLlcData(state.insightsProperty.propertyId, action.payload.ocCompany);
    }
    return {
      ...state,
      ...action.payload
    };
  case UPDATE_CALL_CONSOLE_AI_COMPANY_FEEDBACK: {
    const updatedAiRelatedCompanies = state.aiRelatedCompanies?.map((company) => {
      return company.id === action.payload.aiCompanyId
        ? { ...company, feedback: action.payload.feedback }
        : company;
    });

    return { ...state, aiRelatedCompanies: updatedAiRelatedCompanies };
  }
  case UPDATE_CALL_CONSOLE_OWNERSHIP_FEEDBACK: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.id === action.payload.ownershipId
        ? { ...owner, feedback: action.payload.feedback }
        : owner;
    });

    return { ...state, owners: updatedOwners };
  }
  case SET_CALL_CONSOLE_VERIFIED_OWNER: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.id === action.payload.ownerId
        ? { ...owner, verified: action.payload.verified }
        : owner;
    });
    return { ...state, owners: updatedOwners };
  }
  case SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE: {
    const updatedOwners = state.owners?.map((owner) => {
      if (owner.id === action.payload.ownerId) {
        const { contactMethodKey, contactMethodId, newScore } = action.payload;
        return {
          ...owner,
          contact: {
            ...owner.contact,
            [contactMethodKey]: owner.contact[contactMethodKey].map(cm => ({
              ...cm,
              connectRankScore: cm.id === contactMethodId ? newScore : cm.connectRankScore
            }))
          }
        };
      }
      return owner;
    });
    return { ...state, owners: updatedOwners };
  }
  case DELETE_CALL_CONSOLE_OWNERSHIP: {
    const updatedOwners = state.owners?.filter(owner => owner.id !== action.payload.ownerId);
    return { ...state, owners: updatedOwners };
  }
  case ADD_CALL_CONSOLE_OWNERSHIP: {
    const updatedOwners = [action.payload, ...(state.owners || [])];
    return { ...state, owners: updatedOwners };
  }
  case UPDATE_CALL_CONSOLE_CONTACT: {
    const updatedOwners = state.owners?.map((owner) => {
      return owner.contact.id === action.payload.id
        ? {
          ...owner,
          contact: {
            ...owner.contact,
            ...action.payload
          }
        }
        : owner;
    });
    return { ...state, owners: updatedOwners };
  }
  case SET_CALL_LIST_ITEM_ID:
    return { ...state, callListItemId: action.payload };
  default:
    return state;
  }
}
